import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IWasteDoc} from "../../../../../../utils/interfaces/special_wasty/waste_doc/IWasteDoc";


const useApiGetWasteDocsByRecipient = (doc_type: string, recipient_id: number | undefined): UseQueryResult<IWasteDoc[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IWasteDoc[]> {
        try {
            const response = await get(`/api/company/${company_token}/special_wasty/waste_doc?doc_type=${doc_type}&recipient_id=${recipient_id}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWasteDocsByRecipient", doc_type, recipient_id],
        queryFn: () => doGet(selectedCompany?.company_token,),
        enabled: !!recipient_id,
    })
};

export default useApiGetWasteDocsByRecipient